import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mockData';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1646956141271-05281b4ef472"
          alt="Thermal Treatment Laboratory"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/90 to-gray-900/85"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-32">
        <div className="max-w-5xl mx-auto text-center">
          {/* Main Headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-400">
              CATCHING ENERGY SDN. BHD.
            </span>
          </h1>

          {/* Subheading */}
          <div className="bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl p-8 mb-6 max-w-4xl mx-auto">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight">
              Rapid Thermal Treatment & Custom High-Temperature Material Synthesis
            </h2>
            <p className="text-lg text-gray-300 mb-4">
              {companyInfo.description}
            </p>
            <div className="inline-flex items-center bg-green-600 rounded-full px-6 py-3 mt-2">
              <span className="text-3xl font-bold text-white">RM XX</span>
              <span className="text-lg text-white/90 ml-2">per sample</span>
            </div>
          </div>

          {/* CTA Button */}
          <Button
            onClick={() => scrollToSection('contact')}
            size="lg"
            className="bg-green-600 hover:bg-green-700 text-white text-xl px-12 py-8 group shadow-2xl mb-16"
          >
            Request Sample Processing
            <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" />
          </Button>

          {/* Quick Info */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6">
              <div className="text-3xl font-bold text-green-400 mb-2">600-3,000°C</div>
              <div className="text-sm text-gray-300">Temperature Range</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6">
              <div className="text-3xl font-bold text-blue-400 mb-2">1-60s</div>
              <div className="text-sm text-gray-300">Processing Time</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6">
              <div className="text-3xl font-bold text-white mb-2">Custom</div>
              <div className="text-sm text-gray-300">Specifications</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
